import React from "react";
import { Wrapper, Text } from "./styledComponents";
import Modal from "components/Modal";

const VerificationResentSuccessModal = ({ close }) => (
  <Modal close={close} title="Success">
    <Wrapper>
      <Text>
        We have sent you another email with a link to verify your email address.
      </Text>
    </Wrapper>
  </Modal>
);

export default VerificationResentSuccessModal;



// WEBPACK FOOTER //
// ./src/components/VerificationResentSuccessModal/index.js